import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { apiParamethor } from '@/api'
import { queryKeys } from '@/query/queryKeys'
import { sleep } from '@/utils/sleep'

export function useParameters(uid: string | undefined, debounce = false) {
  return useQuery({
    queryKey: queryKeys.parameters(uid),
    queryFn: async () => {
      if (debounce) {
        await sleep(800)
      }
      if (uid && uid.length > 0) {
        const response = await apiParamethor.getParameters(uid)
        return response
      }
    },
    placeholderData: keepPreviousData,
    enabled: !!uid,
  })
}
